import React from 'react'

import {
  DateField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  batchType: { id: 'batchTypeDisplay', label: 'Type', ordering: 'batch_type', renderer: LinkedField(ValueField) },
  client: { id: 'client', label: 'Client', ordering: 'client__name', renderer: RelatedLinkedField(ValueField, 'name') },
  clientId: { id: 'clientId', label: 'Number', ordering: 'client_uid', renderer: ValueField },
  expiresOn: { id: 'expiresOn', label: 'Expires On', ordering: 'expires_on', renderer: DateField },
  asn: { id: 'asn', label: 'ASN', ordering: 'asn__tracking_number', renderer: RelatedLinkedField(ValueField, 'name') },
}

export const BatchListTable = (props: ListTableProps) => {
  const { paginator, fields, title = "Batches" } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
